import { Link } from "@tanstack/react-router";

export function NotFoundPage() {
  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-background px-4">
      <div className="max-w-2xl w-full text-center">
        <p className="text-[10px] font-medium uppercase tracking-[0.22em] text-pink-soft mb-4">
          404
        </p>
        <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-foreground mb-4">
          Page not found
        </h1>
        <p className="text-muted-foreground mb-10 max-w-sm mx-auto">
          We couldn't find that page. Try one of the links below to find what you're looking for.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 max-w-xl mx-auto">
          <NavLink to="/" label="Home" />
          <NavLink to="/products" label="Products" />
          <NavLink to="/pricing" label="Pricing" />
          <NavLink to="/blog" label="Blog" />
          <NavLink to="/case-studies" label="Case studies" />
          <NavLink to="/comparisons" label="Comparisons" />
          <NavLink to="/tutorials" label="Tutorials" />
          <NavLink to="/geo" label="GEO fundamentals" />
          <NavLink to="/use-cases" label="Use cases" />
          <NavLink to="/about" label="About" />
        </div>
      </div>
    </div>
  );
}

function NavLink({ to, label }: { to: string; label: string }) {
  return (
    <Link
      to={to}
      className="rounded-lg border border-border/60 bg-card/40 hover:bg-card/70 hover:border-border transition-all px-4 py-3 text-sm font-medium text-foreground"
    >
      {label}
    </Link>
  );
}
